// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useRef } from 'react';
import { fireNonCancelableEvent } from '../../events';
export const useLoadItems = ({ onLoadItems, isEmpty, statusType }) => {
    const prevFilteringText = useRef(undefined);
    const fireLoadItems = (filteringText) => {
        if (prevFilteringText.current === filteringText) {
            return;
        }
        prevFilteringText.current = filteringText;
        fireNonCancelableEvent(onLoadItems, { filteringText, firstPage: true, samePage: false });
    };
    const handleLoadMore = () => {
        if (statusType === 'pending') {
            fireNonCancelableEvent(onLoadItems, {
                firstPage: isEmpty,
                samePage: false,
                filteringText: prevFilteringText.current || '',
            });
        }
    };
    const handleRecoveryClick = () => fireNonCancelableEvent(onLoadItems, {
        firstPage: false,
        samePage: true,
        filteringText: prevFilteringText.current || '',
    });
    return {
        fireLoadItems,
        handleLoadMore,
        handleRecoveryClick,
    };
};
//# sourceMappingURL=index.js.map